import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SelectLanguage from '../../components/register/SelectLanguage';
import Languages from '../../constants/Languages';
import * as Actions from '../../store/Actions';

function LanguageScreen(props) {
  const { actions, navigation, registration } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    Languages.languages.forEach((rec, index) => {
      if (rec.name == registration.language.name) {
        setSelectedIndex(index);
      }
    });
  }, [registration.language]);

  const onChange = (index) => {
    setSelectedIndex(index);
    actions.selectLanguage(index);
  };

  const goNext = () => {
    // PhoneOrEmail is default, change to whatever you want to build/test
    // Language: 'language',
    // PhoneOrEmail: 'welcome',
    // VerificationEmailSent: 'verification_email_sent',
    // CreatePassword: 'create_password',
    // EnterPassword: 'password',
    // EnterPhone: 'phone',
    // EnterEmail: 'email',
    // TermsPrivacy: 'terms',
    // EmailVerified: 'email_verified',
    // OtpCode: 'otp',
    // UserDetails: 'user_details',
    // FamilyDetails: 'family_details',
    // AdditionalDetails: 'additional_details',
    // AccountCreated: 'account_created',
    navigation.navigate('PhoneOrEmail');
  };

  const goBack = () => {
    navigation.navigate('a', { screen: 'pantries' });
  };

  let locale = 'en';
  if (selectedIndex) {
    locale = Languages.languages[selectedIndex].name;
  }
  const translation = Languages.translations[locale];

  return (
    <SelectLanguage
      checkedItem={selectedIndex}
      onChange={onChange}
      translation={translation}
      goNext={goNext}
      goBack={goBack}
    />
  );
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

LanguageScreen.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  registration: PropTypes.objectOf(PropTypes.any).isRequired,
  navigation: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageScreen);
